import React, {} from 'react'

const ActiveForm = props => {        
    const {content, form, step}  = props;
    return (
        <div className="active-form">
            <div className="text-step">Steg {step} av 4</div>
            <div className="text-title">{content.heading}</div>   
            <div className="text-desc">{content.desc}</div> 
            {form}                    
        </div>
    )    
}

export default ActiveForm
